// Safe wrappers around localStorage so the JWT flow never crashes on a
// QuotaExceededError. Historically we JSON-stringified the full `user`
// document, which for bank_staff includes `photo_b64` + `id_card_b64` —
// each a full base64 selfie/ID card. Two accounts and localStorage is dead.
//
// Rule: keep ONLY the minimum needed to render the shell (name/phone/role
// display, role-based routing) and drop every heavy field. Pages that need
// the full profile refetch it via /auth/me.

const SLIM_KEYS = [
  "id", "role", "sub_role", "name", "phone", "email",
  "district", "managed_district",
  "bank_id", "bank_name", "branch_id", "branch_name",
  "status", "vip", "score",
  "_impersonation",
];

export function slimUser(user) {
  if (!user || typeof user !== "object") return user;
  const out = {};
  for (const k of SLIM_KEYS) {
    if (user[k] !== undefined) out[k] = user[k];
  }
  return out;
}

export function safeSetItem(key, value) {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    // QuotaExceededError, SecurityError (Safari private mode), etc.
    try {
      // Free the biggest offender and retry once with a slimmed payload.
      if (key === "shakthi_user" || key === "shakthi_admin_user") {
        localStorage.removeItem(key);
      }
      localStorage.setItem(key, value);
      return true;
    } catch (_e2) {
      console.warn("[storage] setItem failed for", key, e?.name || e);
      return false;
    }
  }
}

export function safeSetUser(key, user) {
  const raw = JSON.stringify(slimUser(user));
  return safeSetItem(key, raw);
}
